module.exports = __webpack_public_path__ + "img/ic_pattern-yellow-2x.de0eab13.png";